import { useTranslation } from 'react-i18next'

const btnClassName =
  'd-flex flex-column justify-content-start align-items-center text-center pt-4 gap-2 contact-sidebar-btn'

export const ContactOptions = ({
  onSupportRequest,
}: {
  onSupportRequest: () => void
}): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="d-flex flex-row justify-content-around">
      <div
        className={btnClassName}
        onClick={() =>
          window.open('https://support.tcgpowertools.com/support/kb/categories', '_blank')
        }
      >
        <i className="fa-solid fa-book" />
        <span>{t('navigation.knowledgeBase')}</span>
      </div>

      <div
        className={btnClassName}
        onClick={() => window.open('https://discord.gg/y7Rz34hgqJ', '_blank')}
      >
        <i className="fa-brands fa-discord" />
        <span>{t('navigation.discord')}</span>
      </div>

      <div className={btnClassName} onClick={onSupportRequest}>
        <i className="fa-solid fa-headset" />
        <span>{t('navigation.openSupportRequest')}</span>
      </div>
    </div>
  )
}
